var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarragePhotovoltaique(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "BarragePhotovoltaique_svg__a",
    d: "M5.333 5.333h53.333v53.333H5.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.576)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "BarragePhotovoltaique_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BarragePhotovoltaique_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.889 30H81.11c1.227 0 2.222.995 2.222 2.222v.89a2.222 2.222 0 01-2.222 2.221H30.89a2.222 2.222 0 01-2.222-2.222v-.889c0-1.227.995-2.222 2.222-2.222z",
    fill: "#FFB511",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    transform: "rotate(90 56 32.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 9.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 13.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 17.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 21.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 41.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 45.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 49.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 53.333,
    width: 44,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 33.905a2.857 2.857 0 00-5.715 0v8c0 .412-.256.747-.571.747-.316 0-.572-.335-.572-.747V27.619a2.857 2.857 0 00-5.715 0v14.286c0 .412-.256.747-.571.747-.316 0-.572-.335-.572-.747V24.19a2.857 2.857 0 00-5.715 0v17.715c0 .412-.255.747-.571.747-.316 0-.572-.335-.572-.747v-12a2.857 2.857 0 00-5.714 0v18.98l-3.692-3.69a3.429 3.429 0 00-4.849 4.848l8.54 8.54v16.084H58.5V33.905z",
    fill: "#0F1941",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    transform: "rotate(-30 40.583 48)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 25.333,
    width: 18.667,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 29.333,
    width: 18.667,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 33.333,
    width: 14.667,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E74536",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    x: 10.667,
    y: 37.333,
    width: 16,
    height: 1.333,
    rx: 0.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.444 30.667h50.222c1.227 0 2.222.995 2.222 2.222v.889A2.222 2.222 0 0133.778 36h-50.222a2.222 2.222 0 01-2.223-2.222v-.89c0-1.226.995-2.221 2.223-2.221z",
    fill: "#FFB511",
    mask: "url(#BarragePhotovoltaique_svg__b)",
    transform: "rotate(90 8.667 33.333)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjUiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NSA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iOHBtZmRwM3l1YSIgZD0iTTUuMzMzIDUuMzMzaDUzLjMzM3Y1My4zMzNINS4zMzN6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSguNTc2KSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iejBoc2w0dzE0YiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzhwbWZkcDN5dWEiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHBhdGggZD0iTTMwLjg4OSAzMEg4MS4xMWMxLjIyNyAwIDIuMjIyLjk5NSAyLjIyMiAyLjIyMnYuODlhMi4yMjIgMi4yMjIgMCAwIDEtMi4yMjIgMi4yMjFIMzAuODlhMi4yMjIgMi4yMjIgMCAwIDEtMi4yMjItMi4yMjJ2LS44ODljMC0xLjIyNy45OTUtMi4yMjIgMi4yMjItMi4yMjJ6IiBmaWxsPSIjRkZCNTExIiBtYXNrPSJ1cmwoI3owaHNsNHcxNGIpIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA1NiAzMi42NjcpIi8+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3NDUzNiIgbWFzaz0idXJsKCN6MGhzbDR3MTRiKSIgeD0iMTAuNjY3IiB5PSI5LjMzMyIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjEuMzMzIiByeD0iLjY2NyIvPgogICAgICAgIDxyZWN0IGZpbGw9IiNFNzQ1MzYiIG1hc2s9InVybCgjejBoc2w0dzE0YikiIHg9IjEwLjY2NyIgeT0iMTMuMzMzIiB3aWR0aD0iNDQiIGhlaWdodD0iMS4zMzMiIHJ4PSIuNjY3Ii8+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3NDUzNiIgbWFzaz0idXJsKCN6MGhzbDR3MTRiKSIgeD0iMTAuNjY3IiB5PSIxNy4zMzMiIHdpZHRoPSI0NCIgaGVpZ2h0PSIxLjMzMyIgcng9Ii42NjciLz4KICAgICAgICA8cmVjdCBmaWxsPSIjRTc0NTM2IiBtYXNrPSJ1cmwoI3owaHNsNHcxNGIpIiB4PSIxMC42NjciIHk9IjIxLjMzMyIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjEuMzMzIiByeD0iLjY2NyIvPgogICAgICAgIDxyZWN0IGZpbGw9IiNFNzQ1MzYiIG1hc2s9InVybCgjejBoc2w0dzE0YikiIHg9IjEwLjY2NyIgeT0iNDEuMzMzIiB3aWR0aD0iNDQiIGhlaWdodD0iMS4zMzMiIHJ4PSIuNjY3Ii8+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3NDUzNiIgbWFzaz0idXJsKCN6MGhzbDR3MTRiKSIgeD0iMTAuNjY3IiB5PSI0NS4zMzMiIHdpZHRoPSI0NCIgaGVpZ2h0PSIxLjMzMyIgcng9Ii42NjciLz4KICAgICAgICA8cmVjdCBmaWxsPSIjRTc0NTM2IiBtYXNrPSJ1cmwoI3owaHNsNHcxNGIpIiB4PSIxMC42NjciIHk9IjQ5LjMzMyIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjEuMzMzIiByeD0iLjY2NyIvPgogICAgICAgIDxyZWN0IGZpbGw9IiNFNzQ1MzYiIG1hc2s9InVybCgjejBoc2w0dzE0YikiIHg9IjEwLjY2NyIgeT0iNTMuMzMzIiB3aWR0aD0iNDQiIGhlaWdodD0iMS4zMzMiIHJ4PSIuNjY3Ii8+CiAgICAgICAgPHBhdGggZD0iTTU4LjUgMzMuOTA1YTIuODU3IDIuODU3IDAgMCAwLTUuNzE1IDB2OGMwIC40MTItLjI1Ni43NDctLjU3MS43NDctLjMxNiAwLS41NzItLjMzNS0uNTcyLS43NDdWMjcuNjE5YTIuODU3IDIuODU3IDAgMCAwLTUuNzE1IDB2MTQuMjg2YzAgLjQxMi0uMjU2Ljc0Ny0uNTcxLjc0Ny0uMzE2IDAtLjU3Mi0uMzM1LS41NzItLjc0N1YyNC4xOWEyLjg1NyAyLjg1NyAwIDAgMC01LjcxNSAwdjE3LjcxNWMwIC40MTItLjI1NS43NDctLjU3MS43NDctLjMxNiAwLS41NzItLjMzNS0uNTcyLS43NDd2LTEyYTIuODU3IDIuODU3IDAgMCAwLTUuNzE0IDB2MTguOThsLTMuNjkyLTMuNjlhMy40MjkgMy40MjkgMCAwIDAtNC44NDkgNC44NDhsOC41NCA4LjU0djE2LjA4NEg1OC41VjMzLjkwNXoiIGZpbGw9IiMwRjE5NDEiIG1hc2s9InVybCgjejBoc2w0dzE0YikiIHRyYW5zZm9ybT0icm90YXRlKC0zMCA0MC41ODMgNDgpIi8+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3NDUzNiIgbWFzaz0idXJsKCN6MGhzbDR3MTRiKSIgeD0iMTAuNjY3IiB5PSIyNS4zMzMiIHdpZHRoPSIxOC42NjciIGhlaWdodD0iMS4zMzMiIHJ4PSIuNjY3Ii8+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3NDUzNiIgbWFzaz0idXJsKCN6MGhzbDR3MTRiKSIgeD0iMTAuNjY3IiB5PSIyOS4zMzMiIHdpZHRoPSIxOC42NjciIGhlaWdodD0iMS4zMzMiIHJ4PSIuNjY3Ii8+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3NDUzNiIgbWFzaz0idXJsKCN6MGhzbDR3MTRiKSIgeD0iMTAuNjY3IiB5PSIzMy4zMzMiIHdpZHRoPSIxNC42NjciIGhlaWdodD0iMS4zMzMiIHJ4PSIuNjY3Ii8+CiAgICAgICAgPHJlY3QgZmlsbD0iI0U3NDUzNiIgbWFzaz0idXJsKCN6MGhzbDR3MTRiKSIgeD0iMTAuNjY3IiB5PSIzNy4zMzMiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxLjMzMyIgcng9Ii42NjciLz4KICAgICAgICA8cGF0aCBkPSJNLTE2LjQ0NCAzMC42NjdoNTAuMjIyYzEuMjI3IDAgMi4yMjIuOTk1IDIuMjIyIDIuMjIydi44ODlBMi4yMjIgMi4yMjIgMCAwIDEgMzMuNzc4IDM2aC01MC4yMjJhMi4yMjIgMi4yMjIgMCAwIDEtMi4yMjMtMi4yMjJ2LS44OWMwLTEuMjI2Ljk5NS0yLjIyMSAyLjIyMy0yLjIyMXoiIGZpbGw9IiNGRkI1MTEiIG1hc2s9InVybCgjejBoc2w0dzE0YikiIHRyYW5zZm9ybT0icm90YXRlKDkwIDguNjY3IDMzLjMzMykiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgBarragePhotovoltaique as ReactComponent };